(function(angular) {
  'use strict';

  angular.module('asSecureCommerce', ['osiAssets']);
})(window.angular);
